import { ServerDate } from "@eres/core";
import { HTLookup } from "@10x/handtakeover/api/entities";

export interface Person {
	DOB: ServerDate;
	EmiratesId: string;
	Fax?: any;
	Gender: number;
	GovernmentComanyNameAr?: any;
	GovernmentComanyNameEn?: any;
	IsGCCNational: boolean;
	LicenseExpiryDate?: any;
	LicenseIssueDate?: any;
	LicenseIssuer?: any;
	LicenseIssuerEmirate?: any;
	LicenseNo?: any;
	LicenseStateId?: any;
	Mobile: string;
	NationalityId: number;
	PassportExpiryDate: ServerDate;
	PassportIssueDate: ServerDate;
	PassportIssuePlace: string;
	PassportIssuePlaceAr: string;
	PassportNo: string;
	PlaceOfBirthID?: any;
	ResidenceVisaNumber: string;
	UIdNumber: string;
	VatNumber?: any;
	VisaExpiryDate: ServerDate;
	VisaStartDate: ServerDate;
}

export interface CoOccupantInfo {
	CoTenants: CoOccupant[];
	TotalCoTenants?: number;
	AllowedCoTenants?: number;
}

export interface CoOccupant {
	Company?: any;
	Email?: string;
	Fax?: string;
	IsCompany: boolean;
	IsPrimary: boolean;
	Person: Person;
	Phone?: any;
	Pobox?: string;
	TenantArabicName?: string;
	TenantEnglishName?: string;
	TenantId: number;
	TenantNumber: string;
	TenantParticipantId: number;
	IsTemp?: boolean;
	SpecialCase?: boolean;
}

interface CoOccupantProperty {
	IsFreeHold: boolean;
	PropertyTypeId: number;
	PropertyId: number;
	OwnerId: number;
}

export interface CoOccupantPropertyInfo {
	EjariPropertyId: number[];
	ContractType: number;
	ContractId?: number;
	ActiveUserType: number;
	ActiveUserID: number;
	PropertyDetails?: CoOccupantProperty;
}

export interface CoOccupantSearchInfo {
	EmiratesId: string;
	NationalityCountryId: string;
	PassportNo: string;
	TenantNumber: string;
	mobileNumber: string;
	DOB: ServerDate;
}

export function CoOccupantSearchInfo( id: string, dob: ServerDate ): CoOccupantSearchInfo {
	return {
		DOB: dob, EmiratesId: id, NationalityCountryId: "", PassportNo: "", TenantNumber: "", mobileNumber: ""
	};
}

export interface Pet extends HTLookup {
}

export interface PetInfo extends Pet {
	Count: number;
}
